<div class="forgot-password-layout container-fluid form-content shadow-5">
  <div *ngIf="passwordResetSuccess" class="mt-5">
    <div class="alert alert-success" role="alert" data-mdb-color="success">
      <h4 class="alert-heading">We have received your password reset request.</h4>
      <p>
        As long as the e-mail address you provided matches our records, we will be sending you a one-time password and next steps.
        <br/>
      </p>
      <hr>
      <p class="mb-0">
        If you have not heard from us within 24 hours, please contact <b>developer&#64;gtngroup.com</b>
      </p>
    </div>
    <div class="mr-auto p-2">
      <a [href]="'/'" class="back-to-login-label" type="button"><i class="custom-icon-button2"
                                                                       style="margin-right: 5px;"></i>Return to GTN Developer Portal</a>
    </div>
  </div>

  <div class="form-content" *ngIf="!passwordResetSuccess">
      <h2 class="forgot-password-title" style="text-align: center;">Reset your password</h2>
      <form class="g-3 mt-3" [formGroup]="form" (ngSubmit)="onClickSubmit()" novalidate>
        <p class="text-muted my-2" style="font-size: 0.9rem;">In order to proceed, please confirm the e-mail address with which you registered. We will send out an e-mail with the next steps.</p>
        <label for="email" class="form-label">E-mail Address</label>
        <input type="text" class="form-control" id="email" formControlName="email"
               [ngClass]="{ 'is-invalid': submitted && formControl['email'].errors }">
        <div *ngIf="submitted && formControl['email'].errors" class="invalid-feedback">
          <div *ngIf="formControl['email'].errors['required']">
            E-mail Address is required
          </div>

        </div>
        <button type="button" class="btn btn-primary btn-block my-4" type="submit">
          <div *ngIf="loading" class="spinner-border spinner-border-sm text-light" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p *ngIf="!loading">
            Proceed
          </p>
        </button>
        <div class="text-center">
          <a (click)="goBack()" class="back-to-login-label" type="button">
            <i class="bi bi-arrow-left" style="margin-right: 5px;"></i>Return to Login
          </a>
        </div>

      </form>
  </div>
</div>
